import type { FaireProductEntity } from "../../entity_types/product";

export const p_x5gc49vqnh: FaireProductEntity = {
  token: "p_x5gc49vqnh",
  type: "product",
  name: "Leaf Pile Soy Candle - Fall Collection",
  brandToken: "b_yynur8ww",
  brandName: "Good & Well Supply Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/e43e646f9662103b39f7fa92d73a0bb4e28a5197e9565de62cb12c965b577172.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5f5b1962b14761592ecd47954947ef9f62438a539420e42424fa28059bbc9d82.png",
    "https://cdn.faire.com/fastly/c684c966da9d0983d17f743ab217909c9c0e3e78a46a1662965e8858963c6d24.png",
  ],
  priceDollars: 13,
  description:
    "Scent Notes: Fallen Leaves · Cedarwood · Earth\nThe Vibe: Crunchy trails. Golden afternoons.\n\nThe best part of fall isn't the destination—it's kicking through the leaves on the way there. Leaf Pile captures that unmistakable autumn moment when the trees are glowing, the air is crisp, and every path is covered in gold.\n\nEarthy fallen leaves take center stage, layered with cedarwood and rich forest floor. Familiar, nostalgic, and fleeting, it smells like the season at its absolute peak.\n\nDiameter: 3 in\nHeight: 3 in\nApprox. Net Wt: 7 oz \nApprox. Burn time: 40+ hours\nPhthalate Free\nMade in USA\n\nGood & Well Supply Co. crafts clean candles that celebrate the human connection with nature and inspire exploration. We donate 1% of our annual revenue to nonprofit organizations that protect and conserve national parks and public lands and promote inclusion in the outdoors.\n\nTESTER POLICY:\nLimited to one tester per scent. Testers are 2-oz candles with an easy-to-remove lid for in-store smelling.",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:55.787Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
